import React, { useEffect, useState } from 'react';
import { ICreateExpenseData, ICustomer } from '../../../../@types';
import { CloseIcon } from '../../../../assets/icons';
import { InfoCircle } from '../../../../assets/icons/InfoCircle';
import { useCustomerSearch } from '../../../../hooks';
import { SearchInput } from '../../../common';
import { MiniCard } from '../../../common/TooltipCards/miniCards';
import { CheckboxComponent } from '../../../core/Forms';


interface ExpenseDetailThreeProps {
  validationResults: ICreateExpenseData;
  formData: ICreateExpenseData;
  handleTextAreaChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  total:number;
 expense:ICreateExpenseData;
 handleSelectCustomer:(selectedCustomer: ICustomer | null) => void;
 validateCurrentStep:  () => boolean;
 customer:ICustomer | undefined;
  isBillable:boolean;
  handleIsBillableChange: () => void;
}

const ExpenseDetailThree: React.FC<ExpenseDetailThreeProps> = ({
 
  validationResults,
  handleTextAreaChange,
  formData,
expense,
validateCurrentStep,
handleSelectCustomer,
customer,
isBillable,
handleIsBillableChange,
}) => {
  const [, setCustomer] = useState<ICustomer | undefined>();
 const [total, setTotal] = React.useState<number>(0);
 const [isMiniCardVisible, setIsMiniCardVisible] = useState(false);
  const { data: customers, isSearching: isCustomerSearching, handleSearch: handleCustomerSearch } = useCustomerSearch();
  const [, setFormData] = React.useState<ICreateExpenseData>({
    customerId: undefined,
    isBillable: false,
    category: '',
    currency: 'ngn',
    date: new Date().toISOString().substring(0, 10),
    description: '',
    lineItems: [],
    amount: 0,
    additionalInformation: "",
    notes:"",
    exchangeRate: 0,

  });

  const [, setValidationResults] = React.useState<ICreateExpenseData>({
    customerId: '',
    date: '',
    lineItems: [],
    category: '',
    currency: '',
    description: '',
    isBillable: false,
    vendorName: '',
    amount: 0,
    paymentMethod: '',
    exchangeRate:0,
 
  });

useEffect(() => {
  if (expense) {
    console.log('Fetched expense:', expense);

    setFormData((prevState) => ({
      ...prevState,
      notes: expense.notes,
      amount: expense.amount,
      isBillable: expense.isBillable,
    }));
  }
}, [expense]);

const handleInfoCircleHover = () => {
  setIsMiniCardVisible(true);
};

const handleInfoCircleMouseLeave = () => {
  setIsMiniCardVisible(false);
};

    

  return (
    <div className=' ml-[0.8em]'>
         <h2 className='xl:text-[24px] mt-[1em] text-center'>Fill In Additional Info, If Necessary</h2>
      <div className="flex  lg:justify-center xl:justify-center md:justify-center justify-start gap-[50px] mt-9 ml-[-0.9em] xl:ml-[-11em] biglg:ml-[-15em] lg:ml-[-15em] 540:ml-[-9em] md:ml-[-14em] 375:ml-[-0.9em] 360:ml-[-3.3em] 412:ml-[-0.2em]">
        <label htmlFor="reoccurring" className="font-medium block text-[14px] 375:ml-[-2em] ">
          Billable Expense
        </label>
        <CheckboxComponent
         name=" isBillable" 
        label="" 
        onChange={  handleIsBillableChange} 
        checked={isBillable} />
          <div
                  className="relative hidden lg:block"
                  onMouseEnter={handleInfoCircleHover}
                  onMouseLeave={handleInfoCircleMouseLeave}
                >
                  {isMiniCardVisible ? (
                    <div className="absolute z-10 mt-[1em] ml-[-16em]">
                      <MiniCard
                        text1="Mark an expense as 'Billable' to invoice your "
                        text2=" client for this cost, ensuring you get reimbursed"
                        text3=" for client-related expenses."
                        icon={<InfoCircle />}
                      />
                    </div>
                  ) : (
                    <div className='ml-[-3em]'>
                    <InfoCircle />
                    </div>
                  )}
                </div>
      </div>

      {isBillable && (
        <div className="flex justify-center ml-[-0.9em] mt-[3em] xl:ml-[-7em] biglg:ml-[-8em] lg:ml-[-9em] md:ml-[-8em] 414:ml-[-2em] 412:ml-[] ">
          <span className="text-red-500 ml-[] text-[12px] mt-[-2em]"></span>
          <div className="w-[350px] mt-[-2em] relative ">
            <SearchInput
              placeholder="Search Customer"
              displayKey="name"
              onSelect={handleSelectCustomer}
              handleChangeText={handleCustomerSearch}
              selected={customer}
              data={customers.map((customer) => ({
                ...customer,
                display: `${customer.name} (${customer.phone})`,
              }))}
              isLoading={isCustomerSearching}
              clearIcon={CloseIcon}
              clearIconClass="xl:mr-[2em] mr-[2em] lg:mr-[3em]"
              error={validationResults.customerId}
              dropdownClassName="w-[350px] ml-[0.1em] md:ml-[0.3em] lg:ml-[0.24em] xl:ml-[-0.3em] xl:w-[350px]"
              classNames="border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px] h-[39.77px] rounded p-2 w-[350px]  focus:outline-none focus:shadow-outline appearance-none lg:focus:ring-0 leading-normal"
            />
            {validationResults.customerId && <span className="text-[red]">{validationResults.customerId}</span>}
          </div>
        </div>
      )}

    
<div className='flex justify-center 2xl:ml-[25em] bigmd:ml-[11em]  xl:ml-[21.6em] w-[350px] 375:ml-[-2.2em] md:ml-[6em] md:w-[500px] 414:ml-[-1.5em] ml-[-2em] 360:ml-[-2.7em] 412:ml-[-1.3em] biglg:ml-[15em]'>
      <textarea
        value={formData.notes ?? ''}
        className=" mt-[1em] border  border-[#A4A4A4] md:h-[104px] lg:h-[104px] h-[64px] xl:w-[590px] w-[350px] md:w-[500px] ml-[-2em] rounded-md resize-y overflow-y-auto word-wrap break-word"
        name="notes"
        placeholder="Notes"
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleTextAreaChange(e)}
      />
      </div>
    </div>
  );
};

export default ExpenseDetailThree;
